import { render, staticRenderFns } from "./DialogImportOkr.vue?vue&type=template&id=0ab96285"
import script from "./DialogImportOkr.vue?vue&type=script&lang=js"
export * from "./DialogImportOkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports